/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CalendarConnectionsResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * This user's calendar connections, plus whether connecting is possible.
 * @summary List Calendar Connections
 */
export const listCalendarConnections = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<CalendarConnectionsResponse>(
      {url: `/calendar/connections`, method: 'GET', signal
    },
      options);
    }




export const getListCalendarConnectionsQueryKey = () => {
    return [
    `/calendar/connections`
    ] as const;
    }


export const getListCalendarConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarConnections>>> = ({ signal }) => listCalendarConnections(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCalendarConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarConnections>>>
export type ListCalendarConnectionsQueryError = unknown


/**
 * @summary List Calendar Connections
 */

export function useListCalendarConnections<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCalendarConnectionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






